<template>
  <process-list :singleState='10'/>
</template>

<script>
export default {
	name: "ddcPage",
	components: {
    processList : async () => import('@/components/processList.vue')
  },
	data() {
		return {

		};
	},
	created() {

	},

	mounted() {

	},

};
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/pages/pileThing/securityDoor.vue